export default __webpack_public_path__ + "static/media/Graphics.ff4f9c3f.png";